// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"ad299847","777":"cc6c8c4f","798":"95633f6c"}[chunkId] + ".chunk.css";
};